import { DATA_BACT_LN_MODEL , LOCATE_ENDPOINT_VIEWEACH_KINDLAB , getBaseURLforBackEnd , getConfigAxios  }  from '@/utils.js'
import axios from "axios";

export default {
    namespaced: true,

    state: {

        buffBACTDatPrepareDat : "",
        buffBACTDatCtDat : "",
        dataBACTSpecLN: Object.assign( {} ,DATA_BACT_LN_MODEL) ,

        mstBactDat: [] ,
        mstDrugDat: [] ,
        mstMicDat  : [] ,
        mstResultDat: [],
        mstMethod:[],
        mstMethodResult:[],
        tmplateBact:{}
    },

    getters: {

    },

    mutations: {
        setMstMethod (state, mstMethod) {
            state.mstMethod = mstMethod
        },


        setMstMethodResult (state, mstMethodResult) {
            state.mstMethodResult = mstMethodResult
        },




        setTmplateBact (state, tmplateBact) {
            state.tmplateBact = tmplateBact
        },


        setMstResultDat (state, mstResultDat) {
            state.mstResultDat = mstResultDat
        },

        setMstMicDat (state, mstMicDat) {
            state.mstMicDat = mstMicDat
        },

        setMstDrugDat (state, mstDrugDat) {
            state.mstDrugDat = mstDrugDat
        },

        setMstBactDat (state, mstBactDat) {
            state.mstBactDat = mstBactDat
        },


        setDataBACTSpecLN (state, dataBACTSpecLN) {
            state.dataBACTSpecLN =  dataBACTSpecLN
        },

        setBuffBACTDatPrepareDat (state, buffBACTDatPrepareDat) {
            state.buffBACTDatPrepareDat = buffBACTDatPrepareDat
        },

        setBuffBACTDatCtDat (state, buffBACTDatCtDat) {
            state.buffBACTDatCtDat = buffBACTDatCtDat
        },

    },

    actions: {
        
        // Dev experiment: HTTP-complete actions; legacy actions below are unchanged.
        fetchMiscMasterDataForBactSequential({
          commit
        }, datTo) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`;
          return axios.post(`${getBaseURLforBackEnd()}/api/get_misc_masterdata_for_bact`, datTo, getConfigAxios()).then(res => {
            commit('setMstResultDat', res.data.result_mst);
            commit('setMstMicDat', res.data.mic);
            commit('setMstDrugDat', res.data.drug);
            commit('setMstBactDat', res.data.bact);
            commit('setTmplateBact', res.data.tmplate);
            commit('setMstMethod', res.data.method_mst);
            commit('setMstMethodResult', res.data.method_result_mst);
            return res.data;
          });
        },
produceDoneFetching({commit},doneFetching){
            commit('setDoneFetching', doneFetching)
        },

        produceBuffBACTDatPrepareDat({commit},buffBACTDatPrepareDat){
            commit('setBuffBACTDatPrepareDat', buffBACTDatPrepareDat)
        },

        produceBuffBACTDatCtDat({commit},buffDatCtDat){
            commit('setBuffBACTDatCtDat', buffDatCtDat)
        },



        fetchMiscMasterDataForBact({commit},datTo) {
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_misc_masterdata_for_bact`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setMstResultDat', res.data.result_mst)
                        commit('setMstMicDat', res.data.mic)
                        commit('setMstDrugDat', res.data.drug)
                        commit('setMstBactDat', res.data.bact)
                        commit('setTmplateBact', res.data.tmplate)
                        commit('setMstMethod', res.data.method_mst)
                        commit('setMstMethodResult', res.data.method_result_mst)

                        resolve(res.data)
                    })
            }    )

        },


        fetchBACTOLDDat({commit}, payload) {
            const {shouldApply, ...datTo} = payload
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
            return axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.BACTERIAL}`, datTo, getConfigAxios())
                .then(res => {
                    const prepare = res.data.dat_prepare.dat == null ? '' : Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8')
                    const ct = res.data.dat_ct.dat == null ? '' : Buffer.from(res.data.dat_ct.dat, 'base64').toString('utf-8')
                    if (shouldApply && !shouldApply()) return res.data
                    commit('setDataBACTSpecLN', JSON.parse(JSON.stringify(res.data)))
                    commit('setBuffBACTDatPrepareDat', prepare)
                    commit('setBuffBACTDatCtDat', ct)
                    return res.data
                })
        }

    }
}